import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isServerContext } from '@web/utils';
import { map } from 'rxjs';
import { Route, UrlTreeProviderService } from '@web/common';

const getSignOutUrlTree = (provider: UrlTreeProviderService) => {
  return provider.urlTree((provider) => provider.routerLink(Route.SignOut));
};

export const OnlyLoggedGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const isServer = isServerContext();
  const provider = inject(UrlTreeProviderService);

  // Po stronie serwera robię tymczasowe przekierowanie na stronę ładowania.
  if (isServer) {
    return false;
  }

  return auth
    .isLoggedIn()
    .pipe(
      map((isLoggedIn) =>
        !isLoggedIn ? getSignOutUrlTree(provider) : isLoggedIn,
      ),
    );
};
